import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "../../utils/toast";
import { Button, Modal, Property, Select } from "../ui";
import { useInstitutions } from "./institutions";

const fullName = (user) => [user.firstName, user.lastName].filter(Boolean).join(" ");

// Links an HLI admin account to the institution whose loans it manages
export default function AssignInstitutionModal({ user, onClose, onSuccess }) {
  const [institutionId, setInstitutionId] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => setInstitutionId(""), [user]);

  const { data: institutions = [], isPending } = useInstitutions({ enabled: Boolean(user) });

  const submit = async (event) => {
    event.preventDefault();
    if (!institutionId) {
      toast.warning("Please select an institution.");
      return;
    }
    setSubmitting(true);
    try {
      await axios.put(`${process.env.REACT_APP_BASE_URL}hec/users/admin/assign-institution`, null, {
        params: { userName: user.userName, institutionId },
      });
      // Select values are strings while the ids are numbers
      const institution = institutions.find((i) => String(i.id) === institutionId);
      toast.success(`Institution "${institution?.fullName || "selected"}" assigned to ${fullName(user)}.`, { autoClose: 4000 });
      onSuccess();
    } catch (error) {
      console.error("Failed to assign the institution:", error);
      toast.error(error.response?.data?.message || "Failed to assign institution. Please try again.", { autoClose: 4000 });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={Boolean(user)}
      onClose={onClose}
      dismissible={!submitting}
      title="Assign institution"
      description={user && fullName(user)}
      footer={
        <>
          <Button variant="ghost" size="sm" onClick={onClose} disabled={submitting}>
            Cancel
          </Button>
          <Button size="sm" type="submit" form="assign-institution" loading={submitting}>
            Assign institution
          </Button>
        </>
      }
    >
      {user && (
        <form id="assign-institution" onSubmit={submit} className="flex flex-col gap-5">
          <div>
            <Property label="Email" value={user.email} />
            <Property label="Role" value={user.roleName} />
          </div>
          <Select
            label="Institution"
            required
            placeholder={isPending ? "Loading institutions…" : "Select an institution"}
            disabled={isPending}
            value={institutionId}
            onChange={(e) => setInstitutionId(e.target.value)}
            options={institutions.map((i) => ({ value: String(i.id), label: i.institutionCode ? `${i.fullName} (${i.institutionCode})` : i.fullName }))}
          />
        </form>
      )}
    </Modal>
  );
}
